import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import qs from 'qs'
import {router} from "./router";
import store from "./store";
import bootstrap from 'bootstrap/dist/css/bootstrap.css'
import ElementUI from 'element-ui';
import ElementPlusLocaleRu from 'element-ui/lib/locale/lang/ru-RU';
import 'element-ui/lib/theme-chalk/index.css';
import Paginate from 'vuejs-paginate'
Vue.use('paginate', Paginate)
import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

Vue.config.productionTip = false
Vue.use(qs);
// Vue.use(axios);
Vue.use(ElementUI, {
  locale: ElementPlusLocaleRu,
});
Vue.use(bootstrap);

axios.interceptors.request.use((config) => {
    if(store.getters.token) {
        config.headers['Authorization'] = 'Bearer ' + store.getters.token;
    }

    return config;
});

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

store.dispatch('fetchUser');

new Vue({
  qs,
  router,
  Paginate,
  bootstrap,
  store,
  CKEditor,
  render: h => h(App),
}).$mount('#app')

